module.exports = __webpack_public_path__ + "c46cbebe622aba9b3863d365c1c2f056.svg";